<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <ticket-table></ticket-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ticketTable from './TicketTable.vue'

  export default {
    name: 'ticket',
    components: {ticketTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/ticket/Ticket.vue